import {css} from 'styled-components';

const base = css` 

 *,*:before,*:after{
  box-sizing: border-box;
 }
 
 
 body {
  font: normal 16px/1.5 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

input,textarea {
    width: 100%;
    font-family: inherit;
    height: 40px;
    outline: 0;
    vertical-align: middle;
    background-color: #fff;
    border: 1px solid #CCCCCC;
    border-radius: 3px;
    box-shadow: none;
    padding: 0 12px;
    transition: all 0.25s ease-in-out;

    &:focus {
        outline: 0;
        background-color: #fff;
        border-color: #4A66E2;
        box-shadow: inset 0 0 1px #4A66E2;
        transition: all 0.25s ease-in-out;
    }
}

input {
  hyphens: none;
}

.panel-row {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}

.col-small-6, .col-small-3 {
    box-sizing: border-box;
    flex: 0 0 auto;
    padding-right: 15px;
    padding-left: 15px;
}

.col-small-3 {
    flex-basis: 25%;
    max-width: 25%;
}

.col-small-6 {
    flex-basis: 50%;
    max-width: 50%;
}

.text-center {
    text-align: center;
}

a {
    color: #4A4A4A;
    text-decoration: none;
    transition: all 0.25s ease-in-out;
    
    &:hover, &:focus {
      color: #000;
      transition: all 0.25s ease-in-out;
    }
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
* html .clearfix             { zoom: 1; } /* IE6 */
*:first-child+html .clearfix { zoom: 1; } /* IE7 */


.select2-container{
    width: 100% !important;
}


.react-autosuggest__container {
  position: relative;
}

.react-autosuggest__input {
  width: 100%;
  height: 30px;
  padding: 10px 10px;
  font-family: Helvetica, sans-serif;
  font-weight: 300;
  font-size: 16px;
  border: 1px solid #aaa;
  border-radius: 4px;
  
  // @media only screen and (min-width: 768px) {
  //   width: 240px;
  // }
}

.react-autosuggest__input--focused {
  outline: none;
}

.react-autosuggest__input--open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.react-autosuggest__suggestions-container {
  display: none;
}

.react-autosuggest__suggestions-container--open {
  display: block;
  position: absolute;
  top: 51px;
  width: 280px;
  border: 1px solid #aaa;
  background-color: #fff;
  font-family: Helvetica, sans-serif;
  font-weight: 300;
  font-size: 16px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: 2;
}

.react-autosuggest__suggestions-list {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.react-autosuggest__suggestion {
  cursor: pointer;
  padding: 10px 20px;
}

.react-autosuggest__suggestion--highlighted {
  background-color: #ddd;
}


`;

export default base;



// WEBPACK FOOTER //
// ./src/app/components/styled/global/base.js